//Common utility functions
_.chunkArray = function(arr, len) {
    var chunks = [],
        i = 0,
        n = arr.length;

    while (i < n) {
        chunks.push(arr.slice(i, i += len));
    }
    return chunks;
};


_.inherit = function(childFn, parentFn) {
    childFn.prototype = Object.create(parentFn && parentFn.prototype, {
        constructor: { value: childFn, enumerable: false, writable: true, configurable: true }
    });
};

/**
  * Check if a string ends with a suffix or not
  */
 _.endsWith = function(str, suffix) {
     //Empty string is a valid suffix for all strings
     if (suffix === "") {
         return true;
     }
     if (!str || !suffix) {
         return false;
     }
     var suffixIdx = str.lastIndexOf(suffix);
     return suffixIdx !== -1 && suffixIdx === str.length - suffix.length;
 };

String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
};
